export const token = (state) => state.token // 获取token
export const openId = (state) => state.openId // 获取openId
export const bind = (state) => state.bind // 获取是否绑定微信帐号
export const userInfo = (state) => state.userInfo // 获取用户信息
